export const environment = {
  text:'ESTOY EN AMBIENTE LOCAL',
  BASE_REF: "/certificadosconsulta",

  //apiUrl: 'https://firmasdigitalesqa.spapps.eafit.edu.co/certificadosconsulta/apifirmasdigitales/api/', //EAFITQA
  apiUrl: 'https://app.eafit.edu.co/certificadosconsulta/apifirmasdigitales/api/', //EAFITPDN

  //graphApiToken: "https://firmasdigitalesqa.spapps.eafit.edu.co/certificadosconsulta/apifirmasdigitales/api/Graph/GetAccessToken",//EAFITQA
  graphApiToken: "https://app.eafit.edu.co/certificadosconsulta/apifirmasdigitales/api/Graph/GetAccessToken",//EAFITPDN

  graphApiUrl: "https://graph.microsoft.com/v1.0/",
  graphApiURL: "https://graph.microsoft.com",

  //APPLICATION_ID: "36b9f54f-cf5f-4326-a70d-cfbe88c56d3a", //EAFITQA
  APPLICATION_ID: "c7123090-f73e-4a74-8de7-35095b033337", //EAFITPDN

  //INSTRUMENTATION_KEY: "12af5a05-c7d6-4982-8a6e-91740932cb7a", //EAFITQA
  INSTRUMENTATION_KEY: "2d37e3b3-dec2-4480-b9f5-289059c064ee", //EAFITPDN

  msalConfigAuth: {
    //clientId: "36b9f54f-cf5f-4326-a70d-cfbe88c56d3a",//EAFITQA
    clientId: "c7123090-f73e-4a74-8de7-35095b033337",//EAFITPDN
    //redirectUri: "http://localhost:4200/auth/login", //LOCAL
    //redirectUri: "https://firmasdigitalesqa.spapps.eafit.edu.co/certificadosconsulta/auth/login", //EAFITQA
    redirectUri: "https://app.eafit.edu.co/certificadosconsulta/auth/login", //EAFITPDN
    redirectUrl: "#/home/dashboard",
  },

  redirectUrlPortalEafit: "https://wallet.xertify.co/search-eafit/",

  //Variables de entorno política de reintentos predeterminada
  MAX_RETRY_ERRORS: 3,
  ERROR_DELAY: 1000,
  EXCLUDED_STATUS_CODE: [],

  // Variables de la política de errores

  DEBUG_LOG: true,
  production: false,
  ROLE_NAME_ADMINISTRATION: "Administración",
  ROLE_CONFIGURATION: "Configuración",
  ID_ROLE_CUSTOMER: 21
};
